import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { InsidePageWrapper, Pagination, Typography, Loading } from "@parkschannel/ui";
import { PopularVideoList } from "./PopularVideoList";
import { usePopularVideos } from "../../Pages";
import { useInitialPagination, usePaginationQuery, useScrollTo } from "../../../utils";
export const PopularVideos = ()=>{
    return /*#__PURE__*/ _jsxs(InsidePageWrapper, {
        className: "!mt-12 mb-[56px] md:!mt-[66px] lg:!mt-[112px]",
        id: "popular-videos",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                component: "h2",
                variant: "h3",
                className: "text-neutral-900 mb-6 lg:mb-10",
                children: "Popular videos"
            }),
            /*#__PURE__*/ _jsx(PopularVideoListWithPagination, {})
        ]
    });
};
const PopularVideoListWithPagination = ()=>{
    const { initialPagination  } = useInitialPagination();
    const { scrollTo  } = useScrollTo({
        id: "popular-videos"
    });
    const { usePopularVideosQuery  } = usePopularVideos();
    const { data: videos , isLoading , pagination  } = usePaginationQuery((paginationParams)=>usePopularVideosQuery(paginationParams), {
        initialPagination
    });
    if (isLoading) return /*#__PURE__*/ _jsx(Loading, {});
    if (!videos) return null;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(PopularVideoList, {
                data: videos.data
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex justify-end",
                children: /*#__PURE__*/ _jsx(Pagination, {
                    pagination: pagination,
                    onPageChange: scrollTo
                })
            })
        ]
    });
};
